export default __webpack_public_path__ + "static/media/rlp_dark.5324953f.png";